const useCy = '__CY__';
export function cy(element, params) {
    if (useCy && params) {
        element.setAttribute('data-cy', params);
    }
}
